<template>
  <div class="profile-layout container">
    <div class="sidebar">
      <div class="profile-avatar">
        <div class="avatar-container">
          <!-- <img
            v-if="user.avatar"
            :src="user.avatar"
            :alt="user.name"
            class="avatar"
          /> -->
          <div class="avatar-placeholder">
            <i class="fas fa-user"></i>
          </div>
          <button class="avatar-upload" @click="uploadAvatar" v-if="isEditing">
            <i class="fas fa-camera"></i>
          </button>
        </div>
        <div class="profile-name">{{ user.ten_khach_hang }}</div>
        <div class="profile-email">SĐT: {{ user.dien_thoai }}</div>
      </div>

      <div class="profile-stats">
        <div class="stat-item">
          <span class="stat-number">{{ totalOrders }}</span>
          <span class="stat-label">Đơn hàng</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ formatCurrency(totalSpent) }}</span>
          <span class="stat-label">Tổng chi tiêu</span>
        </div>
      </div>

      <ul class="menu-list">
        <li class="menu-item">
          <a
            href="#"
            class="menu-link"
            :class="{ active: activeTab === 'profile' }"
            @click.prevent="activeTab = 'profile'"
          >
            <i class="fas fa-user"></i>
            Thông tin cá nhân
          </a>
        </li>
        <li class="menu-item">
          <a
            href="#"
            class="menu-link"
            :class="{ active: activeTab === 'orders' }"
            @click.prevent="activeTab = 'orders'"
          >
            <i class="fas fa-shopping-bag"></i>
            Đơn hàng của tôi
          </a>
        </li>
        <li class="menu-item">
          <a
            href="#"
            class="menu-link"
            :class="{ active: activeTab === 'addresses' }"
            @click.prevent="activeTab = 'addresses'"
          >
            <i class="fas fa-map-marker-alt"></i>
            Địa chỉ giao hàng
          </a>
        </li>
        <li class="menu-item">
          <a
            href="#"
            class="menu-link"
            :class="{ active: activeTab === 'security' }"
            @click.prevent="activeTab = 'security'"
          >
            <i class="fas fa-shield-alt"></i>
            Bảo mật
          </a>
        </li>
        <li class="menu-item">
          <a
            href="#"
            class="menu-link logout-link"
            @click.prevent="showLogoutModal = true"
          >
            <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
            Đăng xuất
          </a>
        </li>
      </ul>
    </div>
    <div class="main-content">
      <div v-if="activeTab === 'profile'">
        <div class="content-header">
          <h2 class="content-title">Thông tin cá nhân</h2>
          <button
            class="edit-btn"
            @click="toggleEdit"
            :class="{ cancel: isEditing }"
          >
            <i class="fas" :class="isEditing ? 'fa-times' : 'fa-edit'"></i>
            {{ isEditing ? "Hủy" : "Chỉnh sửa" }}
          </button>
        </div>

        <div class="info-form">
          <div class="form-group">
            <label class="form-label">Họ và tên</label>
            <input
              type="text"
              class="form-input"
              v-model="user.ten_khach_hang"
              :readonly="!isEditing"
              placeholder="Nhập họ và tên..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-input"
              v-model="user.email"
              :readonly="!isEditing"
              placeholder="Nhập email..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Số điện thoại</label>
            <input
              type="tel"
              class="form-input"
              v-model="user.dien_thoai"
              :readonly="!isEditing"
              placeholder="Nhập số điện thoại..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Ngày sinh</label>
            <input
              type="date"
              class="form-input"
              v-model="user.ngay_sinh"
              :readonly="!isEditing"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Nghề nghiệp</label>
            <input
              type="text"
              class="form-input"
              v-model="formData.occupation"
              :readonly="!isEditing"
              placeholder="Nhập nghề nghiệp..."
            />
          </div>

          <div class="form-group full-width">
            <label class="form-label">Địa chỉ</label>
            <textarea
              class="form-textarea"
              v-model="user.dia_chi"
              :readonly="!isEditing"
              placeholder="Nhập địa chỉ đầy đủ"
            ></textarea>
          </div>
        </div>

        <div v-if="isEditing" class="action-buttons">
          <button
            class="btn btn-primary"
            @click="saveProfile"
            :disabled="isSaving"
          >
            <div v-if="isSaving" class="loading"></div>
            <i v-else class="fas fa-save"></i>
            {{ isSaving ? "Đang lưu..." : "Lưu thay đổi" }}
          </button>
          <button class="btn btn-secondary" @click="cancelEdit">
            <i class="fas fa-times"></i>
            Hủy bỏ
          </button>
        </div>

        <!-- <div class="password-section">
          <h3><i class="fas fa-lock"></i> Đổi mật khẩu</h3>
          <div class="info-form">
            <div class="form-group">
              <label class="form-label">Mật khẩu hiện tại</label>
              <input
                type="password"
                class="form-input"
                v-model="passwordData.currentPassword"
                placeholder="Nhập mật khẩu hiện tại"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Mật khẩu mới</label>
              <input
                type="password"
                class="form-input"
                v-model="passwordData.newPassword"
                placeholder="Nhập mật khẩu mới"
              />
            </div>
            <div class="form-group full-width">
              <label class="form-label">Xác nhận mật khẩu mới</label>
              <input
                type="password"
                class="form-input"
                v-model="passwordData.confirmPassword"
                placeholder="Nhập lại mật khẩu mới"
              />
            </div>
          </div>
          <div class="action-buttons">
            <button
              class="btn btn-primary"
              @click="changePassword"
              :disabled="isChangingPassword"
            >
              <div v-if="isChangingPassword" class="loading"></div>
              <i v-else class="fas fa-key"></i>
              {{ isChangingPassword ? "Đang đổi..." : "Đổi mật khẩu" }}
            </button>
          </div>
        </div> -->
      </div>

      <div v-if="activeTab === 'orders'">
        <div class="content-header">
          <h2 class="content-title">Đơn hàng đã mua</h2>
        </div>
        <div class="order-stats">
          <div class="stat-card">
            <span class="stat-number">{{ totalOrders }}</span>
            <span class="stat-label">Tổng đơn hàng</span>
          </div>
          <div class="stat-card">
            <span class="stat-number">{{ completedOrders }}</span>
            <span class="stat-label">Đã hoàn thành</span>
          </div>
          <div class="stat-card">
            <span class="stat-number"></span>
            <span class="stat-label">Đang xử lý</span>
          </div>
          <div class="stat-card">
            <span class="stat-number">{{ formatCurrency(totalSpent) }}</span>
            <span class="stat-label">Tổng chi tiêu</span>
          </div>
        </div>

        <div class="order-filters">
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'all' }"
            @click="setFilter('all')"
          >
            Tất cả
          </button>
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'pending' }"
            @click="setFilter('pending')"
          >
            Chờ xác nhận
          </button>
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'confirmed' }"
            @click="setFilter('confirmed')"
          >
            Đã xác nhận
          </button>
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'shipping' }"
            @click="setFilter('shipping')"
          >
            Đang giao
          </button>
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'Hoàn thành' }"
            @click="setFilter('Hoàn thành')"
          >
            Đã hoàn thành
          </button>
          <button
            class="filter-btn"
            :class="{ active: activeFilter === 'cancelled' }"
            @click="setFilter('cancelled')"
          >
            Đã hủy
          </button>
        </div>

        <div v-if="totalOrders > 0" class="orders-list">
          <div
            v-for="(order, index) in filteredOrders"
            :key="index"
            class="order-card"
          >
            <div class="order-card">
              <div class="order-header">
                <div class="order-info">
                  <div class="order-id">#{{ order.ma_hoa_don }}</div>
                  <div class="order-date">
                    {{ formatDate(order.thoi_gian) }}
                  </div>
                  <div
                    class="order-status"
                    :class="getStatusClass(order.trang_thai)"
                  >
                    {{ getStatusText(order.trang_thai) }}
                  </div>
                </div>
                <div class="order-total">
                  {{ formatCurrency(order.khach_can_tra) }}
                </div>
              </div>

              <div class="order-body">
                <div class="order-items">
                  <div
                    v-for="item in order.items"
                    :key="item.id"
                    class="order-item"
                  >
                    <div class="order-item">
                      <div class="item-image">
                        <img
                          v-if="item.image"
                          :src="getProductAvatar(item.image)"
                          :alt="item.product_name"
                        />
                        <i v-else class="fas fa-image"></i>
                      </div>
                      <div class="item-details">
                        <div class="item-name">{{ item.ten_hang }}</div>
                        <div class="item-price">
                          Giá: {{ formatCurrency(item.gia_ban) }}
                        </div>
                      </div>
                      <div class="item-quantity">x 1</div>
                    </div>
                  </div>

                  <div class="order-actions">
                    <button
                      class="action-btn btn-outline"
                      @click="viewOrderDetails(order)"
                    >
                      <i class="fas fa-eye"></i>
                      Chi tiết
                    </button>

                    <button
                      v-if="order.status === 'pending'"
                      class="action-btn btn-danger"
                      @click="cancelOrder(order)"
                    >
                      <i class="fas fa-times"></i>
                      Hủy đơn
                    </button>

                    <button
                      v-if="order.trang_thai === 'Hoàn thành'"
                      class="action-btn btn-secondary"
                      @click="reviewOrder(order)"
                    >
                      <i class="fas fa-star"></i>
                      Đánh giá
                    </button>

                    <button
                      v-if="['confirmed', 'shipping'].includes(order.status)"
                      class="action-btn btn-primary"
                      @click="trackOrder(order)"
                    >
                      <i class="fas fa-map-marker-alt"></i>
                      Theo dõi
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div style="text-align: center; padding: 50px; color: #666">
              <i
                class="fas fa-shopping-bag"
                style="font-size: 64px; margin-bottom: 20px"
              ></i>
              <h3>Chức năng đang phát triển</h3>
              <p>Danh sách đơn hàng sẽ được hiển thị tại đây</p>
            </div> -->
          </div>

          <div v-if="activeTab === 'addresses'">
            <div class="content-header">
              <h2 class="content-title">Địa chỉ giao hàng</h2>
            </div>
            <div style="text-align: center; padding: 50px; color: #666">
              <i
                class="fas fa-map-marker-alt"
                style="font-size: 64px; margin-bottom: 20px"
              ></i>
              <h3>Chức năng đang phát triển</h3>
              <p>Quản lý địa chỉ giao hàng sẽ được hiển thị tại đây</p>
            </div>
          </div>

          <div v-if="activeTab === 'security'">
            <div class="content-header">
              <h2 class="content-title">Bảo mật tài khoản</h2>
            </div>
            <div style="text-align: center; padding: 50px; color: #666">
              <i
                class="fas fa-shield-alt"
                style="font-size: 64px; margin-bottom: 20px"
              ></i>
              <h3>Chức năng đang phát triển</h3>
              <p>Cài đặt bảo mật sẽ được hiển thị tại đây</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Confirm Logout -->
  <div v-if="showLogoutModal" class="modal-overlay">
    <div class="modal-box">
      <p>Bạn có muốn đăng xuất không?</p>
      <div class="modal-actions">
        <button @click="logout">Đăng xuất</button>
        <button @click="showLogoutModal = false">Hủy</button>
      </div>
    </div>
  </div>
  <InvoiceDetailModal
    v-if="showInvoiceDetailModal"
    :invoice="selectedInvoice"
    @close="showInvoiceDetailModal = false"
  />
</template>

<script setup>
import { useToast } from "@/composables/useToast";
import { customerApi } from "@/services/api";
import { formatCurrency, formatDate } from "@/utils/helpers";
import { computed, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import InvoiceDetailModal from "../modal/invoices/InvoiceDetailModal.vue";

const toast = useToast();
const router = useRouter();
const loading = ref(false);
const activeTab = ref("profile");
const isEditing = ref(false);
const isSaving = ref(false);
// const isChangingPassword = ref(false);
const activeFilter = ref("all");
const totalOrders = ref(0);
const totalSpent = ref(0);
const showLogoutModal = ref(false);
const showInvoiceDetailModal = ref(false);
const selectedInvoice = ref(null);
const invoices = ref([]);

const filteredOrders = computed(() => {
  if (activeFilter.value === "all") {
    return invoices.value;
  }
  return invoices.value.filter(
    (order) => order.trang_thai === activeFilter.value,
  );
});
const completedOrders = computed(() => {
  return invoices.value.filter((order) => order.trang_thai === "Hoàn thành")
    .length;
});
const user = ref({});
const formData = reactive({
  name: "",
  email: "",
  birthday: "",
  occupation: "",
  address: "",
  number_phone: "",
});
// const passwordData = reactive({
//   currentPassword: "",
//   newPassword: "",
//   confirmPassword: "",
// });

let orginalFormData = {};

const viewOrderDetails = (order) => {
  selectedInvoice.value = order;
  showInvoiceDetailModal.value = true;
};
const toggleEdit = () => {
  isEditing.value = !isEditing.value;
  if (isEditing.value) {
    orginalFormData = { ...formData };
  }
};
const cancelEdit = () => {
  isEditing.value = false;
  Object.assign(formData, orginalFormData);
};
const setFilter = (filter) => {
  activeFilter.value = filter;
};

const getStatusText = (status) => {
  const statuses = {
    "Hoàn thành": "Đã hoàn thành",
  };
  return statuses[status] || status;
};

const getStatusClass = (status) => {
  const classes = {
    "Hoàn thành": "status-completed",
  };
  return classes[status] || "status-unknown";
};

const fetchInvoices = async () => {
  loading.value = true;
  try {
    const respones = await customerApi.getInvoices();
    invoices.value = respones.data.data.data || respones.data;
    totalOrders.value = invoices.value.length;
    totalSpent.value = invoices.value.reduce((sum, order) => {
      const amount = Number(order.tong_tien_hang) || 0;
      return sum + amount;
    }, 0);
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Có lỗi xảy ra khi tải đơn hàng";
    toast.error(errorMessage);
  } finally {
    loading.value = false;
  }
};
const fetchInfomationMe = async () => {
  loading.value = true;
  try {
    const response = await customerApi.me();
    user.value = response.data;
  } catch (err) {
    const errorMessage =
      err.response.data.error || "Lỗi lấy thông tin người dùng";
    toast.error(errorMessage);
  } finally {
    loading.value = false;
  }
};
const logout = async () => {
  loading.value = true;
  try {
    await customerApi.logout();
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Có lỗi xảy ra khi đăng xuất";
    toast.error(errorMessage);
  } finally {
    loading.value = false;
    localStorage.removeItem("account_customer_token");
    router.push("/login-customer.html");
    toast.success("Đăng xuất thành công!");
  }
};
onMounted(() => {
  fetchInvoices();
  fetchInfomationMe();
});
</script>

<style scoped>
/* Main Layout */
.profile-layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
  margin: 20px;
}

/* Sidebar */
.sidebar {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 30px;
  height: fit-content;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.profile-avatar {
  text-align: center;
  margin-bottom: 30px;
}

.avatar-container {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
}

.avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.avatar-placeholder {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 48px;
  border: 4px solid #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.avatar-upload {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.avatar-upload:hover {
  background: #0056b3;
  transform: scale(1.1);
}

.profile-name {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.profile-email {
  color: #666;
  font-size: 16px;
  margin-bottom: 20px;
}

.profile-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 30px;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #007bff;
  display: block;
}

.stat-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.menu-list {
  list-style: none;
}

.menu-item {
  margin-bottom: 5px;
}

.menu-link {
  display: flex;
  align-items: center;
  padding: 15px;
  color: #666;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.menu-link:hover,
.menu-link.active {
  /* background: #007bff; */
  background: linear-gradient(135deg, #ffd54f, #f9a825, #f36c21, #e73a1f);
  color: white;
  transform: translateX(5px);
}

.menu-link i {
  margin-right: 15px;
  width: 20px;
}

/* Main Content */
.main-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f1f3f4;
}

.content-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.edit-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  background: #1e7e34;
  transform: translateY(-2px);
}

.edit-btn.cancel {
  background: #dc3545;
}

.edit-btn.cancel:hover {
  background: #bd2130;
}

/* Form Styles */
.info-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 600;
  font-size: 14px;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 15px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.form-input:read-only {
  background: #f8f9fa;
  cursor: not-allowed;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  padding-top: 30px;
  border-top: 2px solid #f1f3f4;
}

.btn {
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  /* background: #007bff; */
  background: linear-gradient(
    135deg,
    #ffd54f,
    #f9a825,
    #f36c21,
    #e73a1f
  ) !important;
  color: white;
}

.btn-primary:hover {
  /* background: #0056b3; */
  background: linear-gradient(
    135deg,
    #111111,
    #3a3a3a,
    #f36c21,
    #ffd54f
  ) !important;
  transform: translateY(-2px);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #bd2130;
  transform: translateY(-2px);
}

/* Password Change Section */
.password-section {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 25px;
  margin-top: 30px;
}

.password-section h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
}

/* Alerts */
.alert {
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-layout {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .sidebar {
    order: 2;
  }

  .main-content {
    order: 1;
  }

  .info-form {
    grid-template-columns: 1fr;
  }

  .content-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .action-buttons {
    flex-direction: column;
  }
}

/* Loading Animation */
.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.order-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 25px;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.order-stats .stat-card .stat-number {
  font-size: 32px;
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: white;
}

.order-stats .stat-card .stat-label {
  font-size: 14px;
  opacity: 0.9;
  color: white;
}

.order-filters {
  display: flex;
  gap: 10px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}

.filter-btn {
  padding: 12px 24px;
  border: 2px solid #e9ecef;
  background: white;
  color: #666;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.filter-btn:hover {
  border-color: #007bff;
  color: #007bff;
}

.filter-btn.active {
  background: #007bff;
  border-color: #007bff;
  color: white;
}

.orders-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.order-card {
  background: white;
  border: 2px solid #f1f3f4;
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.order-card:hover {
  border-color: #007bff;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.order-header {
  background: #f8f9fa;
  padding: 20px 25px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.order-info {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.order-id {
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.order-date {
  color: #666;
  font-size: 14px;
}

.order-status {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-confirmed {
  background: #cce5ff;
  color: #004085;
}

.status-shipping {
  background: #d4edda;
  color: #155724;
}

.status-completed {
  background: #d1ecf1;
  color: #0c5460;
}

.status-cancelled {
  background: #f8d7da;
  color: #721c24;
}

.order-total {
  font-size: 18px;
  font-weight: bold;
  color: #007bff;
}

.order-body {
  padding: 25px;
}

.order-items {
  margin-bottom: 20px;
}

.order-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 0;
  border-bottom: 1px solid #f1f3f4;
  width: 100%;
}

.order-item:last-child {
  border-bottom: none;
}

.item-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}
.item-image img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.item-details {
  flex: 1;
  text-align: left;
}

.item-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.item-variant {
  font-size: 14px;
  color: #666;
  margin-bottom: 3px;
}

.item-price {
  font-weight: 600;
  color: #007bff;
}

.item-quantity {
  background: #f8f9fa;
  padding: 5px 12px;
  border-radius: 15px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.order-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #f1f3f4;
  flex-wrap: wrap;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-outline {
  background: white;
  color: #007bff;
  border: 2px solid #007bff;
}

.btn-outline:hover {
  background: #007bff;
  color: white;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #bd2130;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-overlay .modal {
  display: block;
  background: white;
  border-radius: 15px;
  padding: 30px;
  max-width: 700px;
  width: 90%;
  top: 10%;
  max-height: 80vh;
  overflow-y: auto;
  margin: 0 auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f1f3f4;
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 5px;
}

.modal-close:hover {
  color: #333;
}

/* Responsive */
@media (max-width: 768px) {
  .order-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .order-info {
    width: 100%;
    justify-content: space-between;
  }

  .order-actions {
    justify-content: center;
  }

  .order-filters {
    justify-content: center;
  }

  .filter-btn {
    flex: 1;
    text-align: center;
    min-width: 100px;
  }

  .order-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .order-stats {
    grid-template-columns: 1fr;
  }

  .order-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .item-image {
    align-self: center;
  }
}

/* Modal style */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  text-align: center;
  min-width: 300px;
}

.modal-actions {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.modal-actions button:first-child {
  background: #f44336;
  color: white;
  padding: 6px 12px;
  border-radius: 5px;
  border: none;
}

.modal-actions button:last-child {
  background: #e0e0e0;
  padding: 6px 12px;
  border-radius: 5px;
  border: none;
}
</style>
